export default __webpack_public_path__ + "static/media/menu2.753509c4.png";